import DineroFactory, { DineroObject } from 'dinero.js';
import { CallApi, handleJSONResponse } from './common';
import { Deal } from '@services/deals/types/deal';
// import { HARDCODED_LABEL } from '../store/deals/selectors';

const callAPI = CallApi('deals');

type APIProps =
  | 'created_at'
  | 'updated_at'
  | 'startDate'
  | 'expirationDate'
  | 'revenue';
interface APIDeal extends Omit<Deal, APIProps> {
  created_at: string;
  updated_at: string;
  startDate: string;
  expirationDate: string;
  revenue: DineroObject;
}

const parseAPIDeal = (response: APIDeal): Deal => {
  return {
    ...response,
    created_at: new Date(response.created_at),
    updated_at: new Date(response.updated_at),
    startDate: new Date(response.startDate),
    expirationDate: new Date(response.expirationDate),
    revenue: DineroFactory(response.revenue),
    advance: response.advance
      ? {
          ...response.advance,
          advance: DineroFactory(
            response.advance.advance as unknown as DineroObject
          ),
        }
      : undefined,
    recoupment: response.recoupment
      ? DineroFactory(response.recoupment as unknown as DineroObject)
      : undefined,
  };
};

export const listByOwner = async (ownerId: string): Promise<Deal[]> => {
  const response = await callAPI(`/owner/${ownerId}`, 'GET');

  const list = await handleJSONResponse<APIDeal[]>(response);

  return list.map(parseAPIDeal);
};

export const listByArtist = async (artistId: string): Promise<Deal[]> => {
  const response = await callAPI(`/artist/${artistId}`, 'GET');

  const list = await handleJSONResponse<APIDeal[]>(response);

  return list.map(parseAPIDeal);
};
